var _defs, _rect, _polygon, _path, _rect2, _rect3, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp3CalendarPocketIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c,.g{fill:none;}.b,.c{stroke:#e5e5e5;}.b,.c,.g,.h,.i{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.b,.c,.f{fill-rule:evenodd;}.c{stroke-dasharray:4 6;}.d{fill:#3c3c46;opacity:0.15;}.e{fill:#fff;}.f{fill:#ffefe0;}.g,.h,.i{stroke:#3c3c46;}.h{fill:#89d9fb;}.i{fill:#3ca4ef;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-calendar-pocket-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "36.36 56.27 103.64 56.27 103.64 107.01 70 121.94 36.36 107.01 36.36 56.27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M70,115.19,42.4,102.93V56.27M70,115.19l27.6-12.25V56.27"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 53.54,
    y: 24.06,
    width: 40.92,
    height: 58.48,
    rx: 7.2,
    ry: 7.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 47.54,
    y: 18.06,
    width: 40.92,
    height: 58.48,
    rx: 7.2,
    ry: 7.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M88.46,25.06V69.54a7,7,0,0,1-7,7H68V18.06H81.46A7,7,0,0,1,88.46,25.06Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 52.77,
    y1: 49.77,
    x2: 59.44,
    y2: 49.77
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 52.77,
    y1: 57.49,
    x2: 59.44,
    y2: 57.49
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 52.77,
    y1: 65.21,
    x2: 59.44,
    y2: 65.21
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 52.77,
    y1: 42.05,
    x2: 59.44,
    y2: 42.05
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 64.66,
    y1: 49.77,
    x2: 71.34,
    y2: 49.77
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 64.66,
    y1: 57.49,
    x2: 71.34,
    y2: 57.49
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 64.67,
    y1: 65.21,
    x2: 71.34,
    y2: 65.21
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 64.66,
    y1: 42.05,
    x2: 71.33,
    y2: 42.05
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 76.56,
    y1: 49.77,
    x2: 83.23,
    y2: 49.77
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 76.56,
    y1: 57.49,
    x2: 83.23,
    y2: 57.49
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 76.56,
    y1: 65.21,
    x2: 83.23,
    y2: 65.21
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 76.56,
    y1: 42.05,
    x2: 83.23,
    y2: 42.05
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 47.54,
    y: 28.42,
    width: 20.46,
    height: 5.86
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 68,
    y: 28.42,
    width: 20.46,
    height: 5.86
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 47.54,
    y: 18.06,
    width: 40.92,
    height: 58.48,
    rx: 7.2,
    ry: 7.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp3CalendarPocketIcon);
export default __webpack_public_path__ + "static/media/CP3-calendar-pocket-icon.72243c9a35052ab5938c58de4a8336a9.svg";
export { ForwardRef as ReactComponent };